/*global Modernizr, Splide, mowgli_config, MowgliSlideCurrentSlide, MowgliSlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var homepage_slider = document.querySelector('.homepage-slider');
    if(homepage_slider) {
      const slider = new Splide(homepage_slider, mowgli_config['hero_slider']);

      slider.mount({ MowgliSlideCurrentSlide, MowgliSlideDisableDrag });
    }
}());
